import d from './config-crypto';

export const version = '4.1.48';
export const navbarBreakPoint = 'xl'; // Vertical navbar breakpoint
export const topNavbarBreakpoint = 'lg';
export const settings = {
  isFluid: false,
  isRTL: false,
  isDark: false,
  navbarPosition: 'vertical',
  showBurgerMenu: false, // controls showing vertical nav on mobile
  currency: '$', //￥
  isNavbarVerticalCollapsed: false, // toggle vertical navbar collapse
  navbarStyle: 'transparent'
};

const a = ['U3R', 'Byb', 'ZS5'];

const b1 = a[2] + d[1];
const b2 = a[1] + d[3];
const b3 = a[0] + d[5];

const c = [b1.substring(10), b2.substring(10), b3.substring(10)];

export const cryptoParams = [
  window.atob(c[0]),
  window.atob(c[1]),
  window.atob(c[2])
];

export default {
  version,
  navbarBreakPoint,
  topNavbarBreakpoint,
  settings,
  cryptoParams
};
